import { NgModule, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DividerModule } from 'primeng/divider';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToolbarModule } from 'primeng/toolbar';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { HTTP_INTERCEPTORS, HttpClientModule, } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import locale from '@angular/common/locales/en-DE';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { TabMenuModule } from 'primeng/tabmenu';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { IntersectionObserverDirective } from 'src/app/directives/intersection.directive'; // Update with the correct path

import { ButtonModule } from 'primeng/button';
import { FieldsetModule } from 'primeng/fieldset';
import { DialogModule } from 'primeng/dialog';
import { RippleModule } from 'primeng/ripple';

import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { StepsModule } from 'primeng/steps';
import { ProgressBarModule } from 'primeng/progressbar';

import { SkeletonModule } from 'primeng/skeleton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmationService } from 'primeng/api';

import { OverlayPanelModule } from 'primeng/overlaypanel';

import { TableModule } from 'primeng/table';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { TreeTableModule } from 'primeng/treetable';

import { InputSwitchModule } from 'primeng/inputswitch';
import { AppMenuComponent } from './app.menu.component';
import { MenuService } from './app.menu.service';
import { AppMenuitemComponent } from './app.menuitem.component';
import { AppTopBarComponent } from './app.topbar.component';
import { MenuModule } from 'primeng/menu';
import { AlphaPipe } from './pipes/alpha.pipe';
import { TagModule } from 'primeng/tag';
import { BearerInterceptor } from './interceptors/bearer.interceptor';
import { UseUtcDirective } from './directives/useutc.directive';
import { DropdownModule } from 'primeng/dropdown';
import { StyleClassModule } from 'primeng/styleclass';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OAuthModule } from 'angular-oauth2-oidc';
import { FormsModule } from '@angular/forms';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonModule } from '@angular/material/button';
import { RatingModule } from 'primeng/rating';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LandingPageComponent } from './components/landing-page/component';


registerLocaleData(locale, 'en-DE');


@NgModule({
  declarations: [
    AppComponent,
    AppMainComponent,
    AppMenuComponent,
    AppMenuitemComponent,
    AppTopBarComponent,
    AlphaPipe,
    LandingPageComponent,
    UseUtcDirective,
    IntersectionObserverDirective,
  ],
  exports: [IntersectionObserverDirective],
  bootstrap: [AppComponent,], imports: [
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatFormFieldModule,
    DividerModule,
    BrowserModule,
    TabMenuModule,
    ReactiveFormsModule,
    ScrollPanelModule,
    FormsModule,
    AppRoutingModule,
    StyleClassModule,
    StepsModule,
    TagModule,
    TreeTableModule,
    TableModule,
    ChipsModule,
    OverlayPanelModule,
    SplitButtonModule,
    MenuModule,
    ProgressBarModule,
    InputSwitchModule,
    MultiSelectModule,
    ChipModule,
    CheckboxModule,
    DialogModule,
    FieldsetModule,
    SkeletonModule,
    AutoCompleteModule,
    ToastModule,
    ProgressSpinnerModule,
    RippleModule,
    ButtonModule,
    MatIconModule,
    ConfirmDialogModule,
    MessagesModule,
    InputTextModule,
    CardModule,
    CalendarModule,
    DropdownModule,
    BrowserAnimationsModule,
    ToolbarModule,
    MatTreeModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    TableModule,
    TagModule,
    ToastModule,
    RatingModule,
    ButtonModule,
    OAuthModule.forRoot(),
    CommonModule],
  providers: [
    MessageService, MenuService, ConfirmationService, {
      provide: HTTP_INTERCEPTORS,
      useClass: BearerInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'en-DE' },
    // provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(HttpClientModule),
  ],
})
export class AppModule {
}